import { CFTokens } from '../../../tokens';
//
// New tokens
//
export const ACTIONS_BORDER_COLOR = {
    ALTERNATE: CFTokens.COLOR.BORDER_ALTERNATE_DEFAULT,
    DEFAULT: CFTokens.COLOR.BORDER_DEFAULT,
};
export const BACKGROUND_COLOR = {
    ALTERNATE: CFTokens.COLOR.BACKGROUND_ALTERNATE,
    DEFAULT: CFTokens.COLOR.BACKGROUND_POP,
};
export const ICON_PRESET = {
    ALERT: 'alert-triangle',
    ATTENTION: 'bell',
    DEFAULT: 'crn-logo',
    NEUTRAL: 'bell',
    SUCCESS: 'checkmark',
};
export const ICON_BACKGROUND_COLOR = {
    ALTERNATE: {
        ALERT: 'chromatic-strawberry-alternate-mid-tone',
        ATTENTION: 'chromatic-lemonade-alternate-mid-tone',
        DEFAULT: 'transparent',
        NEUTRAL: 'chromatic-primary-alternate-mid-tone',
        SUCCESS: 'chromatic-forest-alternate-mid-tone',
    },
    DEFAULT: {
        ALERT: 'chromatic-strawberry-mid-tone',
        ATTENTION: 'chromatic-lemonade-default',
        DEFAULT: 'transparent',
        NEUTRAL: 'chromatic-primary-mid-tone',
        SUCCESS: 'chromatic-forest-mid-tone',
    },
};
export const ICON_BORDER_COLOR = {
    ALTERNATE: CFTokens.COLOR.BORDER_ALTERNATE_STRONG,
    DEFAULT: CFTokens.COLOR.TRANSPARENT,
};
export const ICON_FOREGROUND_COLOR = {
    ALTERNATE: {
        ALERT: 'chromatic-strawberry-contrast',
        ATTENTION: 'chromatic-lemonade-contrast',
        DEFAULT: 'text-and-element-accent',
        NEUTRAL: 'text-and-element-default',
        SUCCESS: 'text-and-element-brand',
    },
    DEFAULT: {
        ALERT: 'chromatic-strawberry-contrast',
        ATTENTION: 'chromatic-lemonade-contrast',
        DEFAULT: 'text-and-element-default',
        NEUTRAL: 'text-and-element-default',
        SUCCESS: 'text-and-element-brand',
    },
};
export const ICON_SIZE = {
    DEFAULT: 20,
    MESSAGE: 'lg',
};
export const ICON_WRAPPER_SIZE = 32;
export const MAX_WIDTH = 420;
export const TEXT_COLOR = {
    ALTERNATE: 'text-and-element-alternate-default',
    DEFAULT: 'text-and-element-default',
};
export const TITLE_COLOR = {
    ALTERNATE: {
        ALERT: 'chromatic-strawberry-mid-tone',
        ATTENTION: 'chromatic-lemonade-alternate-mid-tone',
        DEFAULT: 'chromatic-primary-alternate-mid-tone',
        NEUTRAL: 'chromatic-primary-alternate-mid-tone',
        SUCCESS: 'chromatic-forest-alternate-mid-tone',
    },
    DEFAULT: {
        ALERT: 'text-and-element-danger',
        ATTENTION: 'text-and-element-brand',
        DEFAULT: 'text-and-element-default',
        NEUTRAL: 'text-and-element-default',
        SUCCESS: 'chromatic-forest-default',
    },
};
export const TYPE_SPEC_PRESET = {
    MESSAGE: 'Body',
    TITLE: 'Title6',
};
export const TRANSITION_DURATION = 200;
